import React, { useState } from 'react';
import { HoroscopeCard } from './HoroscopeCard';
import { ZODIAC_SIGNS } from './constants';

export const ZodiacSlider: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSign = () => {
    setCurrentIndex((prev) => (prev + 1) % ZODIAC_SIGNS.length);
  };

  const prevSign = () => {
    setCurrentIndex((prev) => (prev - 1 + ZODIAC_SIGNS.length) % ZODIAC_SIGNS.length);
  };

  return (
    <div className="relative">
      <HoroscopeCard
        sign={ZODIAC_SIGNS[currentIndex]}
        onPrev={prevSign}
        onNext={nextSign}
      />
    </div>
  );
};